// @flow

import type { State } from "@store/reducers";
import type {
  AbsenceReviewTask,
  ReferralDecisionTask,
} from "@modules/shared/reducer/absence-review/types";

export const getSharedSlice = (state: State) => state.shared.absenceReview;

export const getLastAbsenceReviewTask = (state: State): ?AbsenceReviewTask =>
  getSharedSlice(state).lastReviewTask;

export const getSelectedAbsenceReviewTask = (state: State): ?AbsenceReviewTask =>
  getSharedSlice(state).selectedReviewTask;

export const selectReferralDecisionTask = (state: State): ?ReferralDecisionTask =>
  state.shared.absenceReview.referralDecisionTask;

export const getReviewTask = (state: State): ?AbsenceReviewTask => getSharedSlice(state).task;
